import { useEffect, useRef } from "react";
import { WS_URL } from "@/lib/api";

// Shared live WebSocket. Reconnects automatically. Calls onMessage(data) for each event.
export function useLiveSocket(onMessage) {
  const cbRef = useRef(onMessage);
  cbRef.current = onMessage;

  useEffect(() => {
    let ws = null;
    let closed = false;
    let retry = null;

    const connect = () => {
      const token = localStorage.getItem("pokedrop_token");
      if (!token) return;
      ws = new WebSocket(`${WS_URL}?token=${token}`);
      ws.onmessage = (e) => {
        try { cbRef.current?.(JSON.parse(e.data)); } catch (_) {}
      };
      ws.onclose = () => {
        if (!closed) retry = setTimeout(connect, 2500);
      };
      ws.onerror = () => { try { ws.close(); } catch (_) {} };
    };
    connect();

    return () => {
      closed = true;
      clearTimeout(retry);
      try { ws && ws.close(); } catch (_) {}
    };
  }, []);
}
